export const ITEM_OPACITY = 1;
export const DRAGGING_ITEM_OPACITY = 0.5;
export const EMPTY_OBJECT = {};
